
















































































































  import qrcode from "./qrcode.vue";
  import { Vue, Component } from "vue-property-decorator";
  import { TradeMode,ServiceType } from "@/model/Base";
  import billService from "@/service/billService";
  import hotelService from "@/service/hotelService";
  import flightService from "@/service/flightService";
  import trainService from "@/service/trainService";
  import trafficService from "@/service/trafficService";
  import { removeKeepalive } from "../modules/keepUtils";
  import axios from "axios";
  import moment from "moment";
  @Component({
    name: "cashier",
    components: {
      qrcode,
    },
    filters: {
      paymentIcon(typeCode: string) {
        return `/static/img/${typeCode}.png`;
      },
    },
  })
  export default class extends Vue {
    CashierInfo = {};
    OrderInfo = {};
    TradeModes = [];
    model = {
      OrderID: "",
      TradeIds: [],
      TradeMode: TradeMode.Alipay,
      TradeType: "",
      PackageID: "",
      ServiceType: "",
      UniqueID: "",
    };
    isPay = false;
    showdialog = false;
    showWechatdialog = false;
    qrdata = "";
    clickCount = 0;
    cashierCreatAt=0;
    isLoading = false;
    get isShowTest() {
      return this.clickCount >= 3 && (location.href.indexOf("test") > -1 || location.href.indexOf("web.ecs.net") > -1);
    }

    get OrderID(): string {
      return this.$route.query.OrderID as string;
    }

    async mounted() {
      let __self = this;
      __self.__init();
      
    }
    beforeUpdate(){
      let __self = this;
// 返回操作
     const cashierCreatAt = sessionStorage.getItem("cashierCreatAt");
     if(cashierCreatAt) {
      __self.cashierCreatAt = Number(cashierCreatAt);
      const cashierInfo =JSON.parse(sessionStorage.getItem("cashierInfo") as string);
      __self.CashierInfo = cashierInfo;
      __self.model.PackageID = cashierInfo.PackageID;
      __self.model.OrderID = cashierInfo.OrderID;
      __self.showWechatdialog = true;
    };
    }
    beforeDestroy() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = 0; // 重置为 0，避免重复清除
      }
    }
    TradeInfos: any[] = [];
    __init() {
      let __self = this;
      __self.model.TradeMode = TradeMode.WeChat;
      billService.cashier(__self.$route.query).then(function(json) {
        if (json.isSucc) {
          let result = json.result;
          let cashierInfo = result.CashierInfo;
          sessionStorage.setItem("cashierInfo", JSON.stringify(cashierInfo));
          __self.CashierInfo = cashierInfo;
          __self.OrderInfo = result.OrderInfo;
          __self.TradeInfos = result.TradeInfos;
          __self.TradeModes = (result.TradeModes || []).filter((o: any) => o.ModeID == TradeMode.WeChat || o.ModeID == TradeMode.Alipay);
          __self.model.TradeIds = result.TradeIds;
          __self.model.OrderID = result.CashierInfo.OrderID;
          __self.model.PackageID = cashierInfo.PackageID;
          __self.model.ServiceType = cashierInfo.ProductType;
          __self.model.UniqueID = cashierInfo.UniqueID;
        }
      });
    }
    redirect() {
      let __self = this;
      __self.model.OrderID = __self.OrderID;
      if (__self.isPay) {
        return;
      }
      let query = __self.$route.query;
      let model = __self.model as any;
      for (const key in query) {
        if (query.hasOwnProperty(key)) {
          model[key] = query[key];
        }
      }
      __self.isPay = true;
      if (model.TradeMode == TradeMode.WeChat) {
        model.TradeType = "MWEB";
      }
      let win = window as any;
      billService.redirect(model).then(json => {
        __self.isPay = false;
        if (!json.isSucc || !json.result) {
          this.$dialog.alert({ message: json.message });
          return;
        }
        var result = json.result;
        if (result.recode) {
          __self.qrdata = result.redirect;
        }
        let userAgent = win.navigator.userAgent;
        if (userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
          location.href = json.result.redirect;
        } else {
          if (result.redirect.indexOf("http://") > -1 || result.redirect.indexOf("https://") > -1) {
            // 点击微信支付
            if(__self.model.TradeMode == TradeMode.WeChat){
              __self.cashierCreatAt = new Date().getTime();
              sessionStorage.setItem("cashierCreatAt", new Date().getTime().toString());
              __self.showWechatdialog = true;
              location.href = json.result.redirect;
            }else{
            location.href = json.result.redirect;
            }
          } else if (win.lch_wechat) {
            win.lch_wechat.pay(result.prepay_id, (json: any) => {
              history.back();
            });
          } else {
            location.href = json.result.redirect;
          }
        }
      });
    }
    ensureFallback(location: any) {
      removeKeepalive(this.$route.fullPath);
      history.replaceState({ target: "index" }, "index", "/");
      this.$router.push(typeof location == "string" ? { path: location } : location);
    }
    runNotify() {
      let OrderID = this.OrderID;
      axios
        .get(`/api/bill/callback/notify?CreateMode=1373&PackageID=${this.model.PackageID}`)
        .catch((error: any) => {
          console.log(error);
        })
        .then((json: any) => {
          console.log(json);
          if (json.data == "success") {
            this.ensureFallback(`/order/details?OrderID=${OrderID}`);
          }
        });
    }
    async getPaymentStatus() {
    let __self = this;
    const res = await billService.getPayStatus(__self.model.PackageID)
    if (res.isSucc) {
     const data:any = res.result;
     const key = data.package.PackageStatus === 1616;
     return key;
     } else {
       throw new Error("请求失败");
     }
    }
    intervalId = 0;
// 新增一个轮询方法
    startPolling() {
    let __self = this;
    let count = 0; // 计数器
    const maxAttempts = 5; // 最多请求 5 次
    const pollInterval = 1500; // 每 1.5 秒请求一次
    return new Promise((resolve) => {
    __self.intervalId = setInterval(async () => {
      const key = await __self.getPaymentStatus();
      count++;
    if (typeof key === 'boolean') {
      if (key) {
        clearInterval(__self.intervalId);
        __self.intervalId = 0;
        resolve(key);
      } else if (count >= maxAttempts) {
        clearInterval(__self.intervalId);
        __self.intervalId = 0;
        resolve(false);
      }
    } else {
      // 处理异常情况，如 key 为 undefined
      clearInterval(__self.intervalId);
      __self.intervalId = 0;
      resolve(false);
    }
    }, pollInterval);
  });
    }
    timer = 0
    async wechatPaySuccess(){
      let __self = this;
      sessionStorage.removeItem("cashierCreatAt");
      __self.isLoading = true;
      __self.showWechatdialog = false;
      const judge = await __self.startPolling();
      sessionStorage.removeItem("cashierInfo");
      if(judge){
        __self.isLoading = false;
        __self.$router.push(`/order/detail?OrderID=${__self.model.OrderID}`)
      }else{
        __self.isLoading = false;
        this.$toast.fail('查询付款状态异常，请稍后重试')
      }
    }
    async wechatPayFail(){
      let __self = this;
      sessionStorage.removeItem("cashierCreatAt");
      __self.isLoading = true;
      __self.showWechatdialog = false;
      const judge = await __self.startPolling();
      sessionStorage.removeItem("cashierInfo");
      if(judge){
        __self.isLoading = false;
        __self.$router.push(`/order/detail?OrderID=${__self.model.OrderID}`)
      }else{
        __self.isLoading = false;
        this.$toast.fail('您还未完成付款，请继续付款')
      }
    }
  }
